import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const fetchDeleteAccountStatus = () => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/profiles/delete_account_requests`,
  });
};

export default fetchDeleteAccountStatus;
